import { GlobalService } from 'src/app/global.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { HttpService } from '../../http.service';
import { AgentService } from '../agent.service';
import { FormControl } from '@angular/forms';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';
import { AgentImagePopupComponent } from '../agent-image-popup/agent-image-popup.component';
import { MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-agent-table',
  templateUrl: './agent-table.component.html',
  styleUrls: ['./agent-table.component.scss'],
})
export class AgentTableComponent implements OnInit {

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  displayedColumns: string[] = ['agent_code', 'id', 'first_name', 'booth_code','booth_type','mobile' ,'gender','adhaar','image','edit'];

  dataSource : any = null;
  agents: Agent[] = [];
  filtered_agents: Agent[] = [];

  // filter
  nameFilter = new FormControl('');
  codeFilter = new FormControl('');
  mobileFilter = new FormControl('');
  filterValues = {
    id: '',
    first_name: '',
    agent_code: '',
    mobile: '',
  };

  // loader
  // data_loaded = false;
  data_loaded = true;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 100;
  title = null;
  constructor(private http: HttpService, public agentService: AgentService, private global: GlobalService,  public dialog: MatDialog) {
    this.title = this.global._active_display_name;
    console.log('angent tage const');
    this.global.set_master_page_title = 'Agent';
    this.agentService.is_display_agent_register_component = true;
    this.getAgent();
    this.agentService.downloadAgent.subscribe((is_update_agent) => {
      console.log(is_update_agent);
      if (is_update_agent) {
        this.getAgent();
      }
    });
  }

  index(index) {
    return index + 1;
  }

  showAgentRegister() {
    this.agentService.is_display_agent_register_component = false;
  }

  hideAgentRegister() {
    this.agentService.is_display_agent_register_component = true;
    this.agentService.agentUpdate.emit(null);
    this.agentService.set_agent_data = null;
  }

  registerAgent() {
    this.showAgentRegister();
    console.log('register zone');
    this.agentService.agentUpdate.emit(null);
    this.agentService.set_agent_data = null;
  }

  editAgent(agent) {
    console.log(agent);
    this.showAgentRegister();
    console.log(agent);
    this.agentService.agentUpdate.emit(agent);
    this.agentService.set_agent_data = agent;
  }

  getAgent() {
    console.log('get agent fun');
    this.http.getAgents().subscribe((data: Agent[]) => {
      this.data_loaded = true;
      console.log(data);
      this.agents = data;
      this.filtered_agents = data;
      // this.dataSource = new MatTableDataSource<Agent>(this.agents);
      // this.dataSource.sort = this.sort;
      // this.dataSource.data = data;
      // this.dataSource.filterPredicate = this.createFilter();
    }, (error) => {
      this.data_loaded = true;
      this.global.showSnakeBar('loading data failed')
      console.log(error);
    });
  }

  ngOnInit() {

    console.log('ng funct');
    this.nameFilter.valueChanges
      .subscribe(
        first_name => {
          this.filterValues.first_name = first_name;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      );
    // code
    this.codeFilter.valueChanges
      .subscribe(
        agent_code => {
          this.filterValues.agent_code = agent_code;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      );
    // mobile
    this.mobileFilter.valueChanges
      .subscribe(
        mobile => {
          this.filterValues.mobile = mobile;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      );

  }

  openDialog(agent_id, image_type): void {
    console.log('dialog open');
    const dialogRef = this.dialog.open(AgentImagePopupComponent, {
      height: '800px',
      width: '1211px',
      data: {
        'agent_id': agent_id,
        'image_type': image_type,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      const res = result;
      console.log(res);
      if ((res !== null) && (res !== undefined)) {
      }
    });
  }



  createFilter():
    (data: any, filter: string) => boolean {
    console.log('filter')
    let filterFunction = function (data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return data.first_name.toString().toLowerCase().indexOf(searchTerms.first_name.toString().toLowerCase()) !== -1
        && data.agent_code.toString().toLowerCase().indexOf(searchTerms.agent_code.toString().toLowerCase()) !== -1
        && data.mobile.indexOf(searchTerms.mobile) !== -1;
    }
    return filterFunction;
  }

  filterAgentCode(agent_code) {
    console.log(agent_code);
    this.filtered_agents = Object.assign([], this.agents).filter(
      item => item.agent_code.toLowerCase().indexOf(agent_code.toLowerCase()) > -1)
  }


}

export interface Agent {
  agent_id: number;
  user_profile_id: number;
  user_id: number;
  first_name: string;
  agent_code: number;
  last_name: string;
  mobile: number;
}
